import { createFileRoute } from "@tanstack/react-router";
import CatalogCategoryPage from "@/site/pages/catalog-category";
import { validateCatalogSearch } from "@/site/components/catalog/catalog-search-schema";

// `/cards` is the "All Cards" root: the same card browser as a category page,
// scoped to every published card (old `/cards`).
export const Route = createFileRoute("/cards/")({
  component: CatalogCategoryPage,
  validateSearch: validateCatalogSearch,
});
